'use strict';

var EntityEnvelope_schema = require('../schema/EntityEnvelope.schema.json.cjs.js');
var ajv = require('./ajv.cjs.js');

function entityEnvelopeSchemaValidator(schema) {
  const validate = ajv.compileAjvSchema(
    schema ? schema : EntityEnvelope_schema.default
  );
  return (data) => {
    const result = validate(data);
    if (result === true) {
      return data;
    }
    throw ajv.throwAjvError(validate.errors);
  };
}

exports.entityEnvelopeSchemaValidator = entityEnvelopeSchemaValidator;
//# sourceMappingURL=entityEnvelopeSchemaValidator.cjs.js.map
